import { Container, makeStyles, Paper } from '@material-ui/core';
import facebookIcon from './facebookIcon2.png';
import instagramIcon from './instagramIcon2.png';
import linkedinIcon from './linkedinIcon2.png';
import mailIcon from './mailIcon.png';
import EmailForm from '../../EmailForm/EmailForm';
import DAAgile from './DAAgile.svg';

export default function ContactUs() {

    const useStyles = makeStyles({
        container: {
            
            "@media (max-width: 576px)": {
                flexDirection:"column"
              },
              "@media (max-width: 720px)": {
                flexDirection:"column"
              },
              "@media (max-width: 1150px)": {
                flexDirection:"column"
              },
              "@media (max-width: 1300px)": {
                flexDirection:"column"
              },
              display: "flex",
        },
        daAgile: {
            maxHeight: "200px",
            maxWidth: "200px"
        },
        aContainer: {
            display: 'grid',
            padding: "30px",
            background: "linear-gradient(130.04deg, #F7E7FF 0%, #FFFFFF 49.48%, #F7E7FF 100%)"
        },
        alignLinks: {
            display: 'inline-flex',
            alignItems: 'center'
        },
        aImgs: {
            direction: "rtl"
        },
        bContainer: {
            display: 'grid',
            padding: "30px",
            backgroundColor: "white"
        }
    });
    const classes = useStyles();
    return (
        <Paper>
            <Container className={classes.container}>
                <Container className={classes.aContainer}>
                    <h2>Contate-nos</h2>
                    <p>Nos mande uma mensagem e iremos te responder em até 48 horas.</p>
                    <div className={classes.alignLinks}>
                        <a href="mailto:contato@direitoagil.com.br"><img src={mailIcon} alt='icone do facebook' /></a><p>contato@direitoagil.com.br</p>
                    </div>
                    <div className={classes.alignLinks}>
                        <a target="_blank" rel="noreferrer" href="https://www.facebook.com/direitoagilwebapp"><img src={facebookIcon} alt='icone do facebook' /></a><p>Direito Ágil</p>
                    </div>
                    <div className={classes.alignLinks}>
                        <a target="_blank" rel="noreferrer" href="https://www.instagram.com/direitoagil1/"><img src={instagramIcon} alt='icone do facebook' /></a><p>@direitoagil</p>
                    </div>
                    <div className={classes.alignLinks}>
                        <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/maria-da-penha-virtual/"><img src={linkedinIcon} alt='icone do facebook' /></a><p>Direito Ágil</p>
                    </div>
                    <div className={classes.aImgs}>
                        <img style={{ width: '100px' }} className={classes.daAgile} src={DAAgile} alt="simbolo da direito agil" />
                    </div>
                </Container>
                <Container className={classes.bContainer}>
                    <EmailForm />
                </Container>
            </Container>
        </Paper>
    );
}